import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TrademarkOutlinedSvg from "@ant-design/icons-svg/es/asn/TrademarkOutlined";
import AntdIcon from "../components/AntdIcon";
var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrademarkOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TrademarkOutlined.displayName = 'TrademarkOutlined';
}
export default /*#__PURE__*/React.forwardRef(TrademarkOutlined);